// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-content[data-v-0bb96509] {
  padding: var(--0bb96509-\\\$getStyles\\.actionItemPadding);
}
.organization-user-table[data-v-0bb96509] {
  min-width: 700px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/settings/Organization.vue","webpack://./Organization.vue"],"names":[],"mappings":"AAEA;EACE,uDAAA;ACDF;ADIA;EACE,gBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.dropdown-content {\n  padding: v-bind(\"$getStyles.actionItemPadding\");\n}\n\n.organization-user-table {\n  min-width: 700px;\n}\n",".dropdown-content {\n  padding: v-bind(\"$getStyles.actionItemPadding\");\n}\n\n.organization-user-table {\n  min-width: 700px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
